module.exports = __webpack_public_path__ + "static/media/c6.114a935b.jpg";